"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var styles = require("../../../styles/ModelResultStyles");
var NumberUtils_1 = require("../../../util/NumberUtils");
var Utils_1 = require("../../../util/Utils");
var ModelResultSummary = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), modelMetadata = _a.modelMetadata, modelMetrics = _a.modelMetrics, type = _a.type;
    if (!modelMetadata || !modelMetrics || !type) {
        return null;
    }
    var goal = modelMetadata.goal, outcomePrediction = modelMetadata.outcomePrediction;
    var summaryHeader = '';
    var listItemMessagePrimary = React.createElement(React.Fragment, null);
    var listItemMessageSecondary = React.createElement(React.Fragment, null);
    if ((0, Utils_1.isBinomialModel)(type)) {
        var binaryValidation = modelMetrics.validation;
        summaryHeader = "".concat(goal, " ").concat(outcomePrediction);
        listItemMessagePrimary = (React.createElement(React.Fragment, null,
            Localize_1.Messages.modelReviewSummaryConfusionMatrix1({ outcomeGoal: outcomePrediction }),
            "\u00A0",
            React.createElement("span", { className: styles.SummaryHighlightNumber }, "26%"),
            "\u00A0",
            Localize_1.Messages.modelReviewSummaryConfusionMatrix2()));
        listItemMessageSecondary = (React.createElement(React.Fragment, null,
            Localize_1.Messages.modelReviewSummaryAUC(),
            "\u00A0",
            React.createElement("span", { className: styles.SummaryHighlightNumber }, (0, NumberUtils_1.formatNumericField)({ value: binaryValidation.auc * 100, fractionDigits: 1, isPercent: true }))));
    }
    else if ((0, Utils_1.isRegressionModel)(type)) {
        var regressionValidation = modelMetrics.validation;
        summaryHeader = "".concat(goal, " '").concat(outcomePrediction, "'");
        listItemMessagePrimary = (React.createElement(React.Fragment, null,
            Localize_1.Messages.modelReviewSummaryRSquare1(),
            "\u00A0",
            React.createElement("span", { className: styles.SummaryHighlightNumber }, (0, NumberUtils_1.formatNumericField)({ value: regressionValidation.r2 * 100, fractionDigits: 1, isPercent: true })),
            "\u00A0",
            Localize_1.Messages.modelReviewSummaryRSquare2()));
        listItemMessageSecondary = (React.createElement(React.Fragment, null,
            Localize_1.Messages.modelReviewSummaryMAE1(),
            "\u00A0",
            React.createElement("span", { className: styles.SummaryHighlightNumber }, (0, NumberUtils_1.formatNumericField)({ value: regressionValidation.mae, fractionDigits: 3 })),
            "\u00A0",
            Localize_1.Messages.modelReviewSummaryMAE2()));
    }
    return (React.createElement("div", { className: styles.SummaryContainer },
        React.createElement("div", { className: styles.SummaryHeader }, "".concat(Localize_1.Messages.modelReviewSummaryHeader(), ": ").concat(summaryHeader)),
        React.createElement("ul", { className: styles.SummaryContent },
            React.createElement("li", null, listItemMessagePrimary),
            React.createElement("li", null, listItemMessageSecondary))));
};
exports.default = ModelResultSummary;
//# sourceMappingURL=ModelResultSummary.js.map